import React from 'react';

import Course, { Variant } from "panels/catalog/entities/Course";
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import CatalogLabels from 'panels/catalog/Catalog.labels';
import IOption from 'common/models/IOption';;
import { DialogView } from 'common/views/dialog/Dialog.view';
import RenderVariants from '../renderVariants';
import MutationButton from 'common/views/button/MutationButton';
import SubscriptionExtend from 'panels/catalog/entities/SubscriptionExtend';
import { ExtensionType } from 'common/constants/Constants';

interface Iprops {
    course: Course,
    actions: any,
    disableDirectBuy: boolean
}

interface Istate {
    isOpen?: boolean
    operation?: IOption<any>
    variant?:Variant
    isFree?: boolean
}


export default class ExtendSubscription extends React.PureComponent<Iprops, Istate>{

    // isFree:boolean= false;
    variantId:string;

    constructor(props: Iprops) {
        super(props)
        this.state = {
            isOpen: false,
            isFree: false
        }
    }

    private _toggleOpen = () => {
        this.setState(prev => ({
            isOpen: !prev.isOpen
        }))
    }

    private extendBuyButton(){
        return (
			this.props.course && this.props.course.variants &&
			<React.Fragment>
				<DialogView isOpen={this.state.isOpen} viewKey="dialog" >
						<RenderVariants variants={this.props.course.variants} 
								addTocart= {(v: Variant) => this.props.actions.addToCart(this.props.course, v, this.props.disableDirectBuy)}
								toggleOpen={() => this._toggleOpen()} 
                                isRepurchase= {true}/>
                    </DialogView>
                    {
                        this.props.course && this.props.course.subscriptionEndDate && !this.props.course.activeSubscriptionExists ?
                            <ButtonView
                               variant={ButtonVariant.PRIMARY}
                               viewKey="catalog.buyCourse"
                                onClick={() => this._toggleOpen()}
                                >
                                    <CatalogLabels.Labels.SubscriptionAddCart />
                            </ButtonView> :
                            <ButtonView
                                variant={ButtonVariant.PRIMARY}
                                viewKey="catalog.extendSub"
                                onClick={() => this._toggleOpen()}
                                >
                                   <CatalogLabels.Labels.SubscriptionExtendBuy />
                            </ButtonView>
                    }
				
			</React.Fragment>
		)
    }
    
    render() {

        return this.state.isFree ? (
            <MutationButton
                variant={ButtonVariant.PRIMARY}
                viewKey="subscription.extend"
                clazz={SubscriptionExtend}
                params={{ id: this.props.course.metaId, variantId: this.variantId }}
                clearCacheOnSuccess={true}
                onSuccess={() => { console.log('extend button onSuccess called....') }}>
                <CatalogLabels.Labels.SubscriptionExtend />
            </MutationButton>
        )
            : (
                <React.Fragment>
                    {this.extendBuyButton()}
                </React.Fragment>
            )
    }

    componentDidMount(): void {
        this.props.course && this.props.course.variants &&
            this.props.course.variants.forEach(variant => {
                if ((variant.price === 0 || variant.price < 0) && ExtensionType.EXISTING_EXTENSION===variant.extensionType) {
                    this.setState({ isFree: true }) 
                    this.variantId= variant.id
                }
            })
    }

}


// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/course/extendSubscription.tsx